import React from "react";

const steps = [
  "Course Information",
  "Course Interface",
  "Upload Documents",
  "Course Message",
];

const AddNewCourseNavigation = ({ currentStep }) => {
  return (
    <div className="stepper mb-10 mb-sm-20 mb-md-29 mt-sm-20 mt-md-30 mt-lg-50">
      {steps.map((label, index) => {
        const stepIndex = index + 1;
        const isCompleted = currentStep > stepIndex;
        const isActive = currentStep === stepIndex;

        return (
          <div
            className={`step ${isCompleted ? "completed" : ""} ${
              isActive ? "active" : ""
            }`}
            key={index}
          >
            <div className="circle">
              {isCompleted ? "✓" : stepIndex.toString().padStart(2, "0")}
            </div>
            <div className="label mt-10">{label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default AddNewCourseNavigation;
